import { useEffect, useState } from "react";

export enum Breakpoints {
  Mobile = 768,
  Tablet = 1024,
}

export function useView(breakpoint: number) {
  const [bpView, setBpView] = useState(true);

  const isView = (breakpoint: number) => {
    return window.innerWidth < breakpoint;
  }

  useEffect(() => {
    const handleResize = () => {
      setBpView(isView(breakpoint));
    };

    window.addEventListener("resize", handleResize);
    setBpView(isView(breakpoint));

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [breakpoint]);

  return bpView;
}
